import type { SVGProps } from "react";
const SvgBullet = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fillRule="evenodd" d="M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 4a6 6 0 1 0 0-12 6 6 0 0 0 0 12" clipRule="evenodd" /></svg>;
export default SvgBullet;